export const TipoReporte = [
    {
        codigoReporte: "M",
        nombreReporte: "MARCAR"
    }, {
        codigoReporte: "D",
        nombreReporte: "DESMARCAR"
    }];

export const obtenerCodigoEnvio = (codigoReporte: string) => {
    return TipoReporte.find(tipoReporte => tipoReporte.codigoReporte === codigoReporte);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_mora/modelo/TipoReporte.ts